/**
 * Table used in UsageTab to display the service usage.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */
import {
  IampHeaderIconTitle,
  IampTableColumnHeader,
} from '@/components/IampTable'
import '@/components/IampTable.css'
import { TaskDetail } from '@/pages/Billing/Invoice'
import { Util } from '@amplify3/duplo-back-end'
import { BiChip, BiCoin, BiCoinStack } from 'react-icons/bi'
import { PiMusicNotes } from 'react-icons/pi'
import { useNavigate } from 'react-router-dom'
import './UsageTaskTable.css'

/**
 * The list of column headers of the task table.
 */
export const UsageTaskTableHeaderList: IampTableColumnHeader[] = [
  {
    icon: <BiChip />,
    title: 'Product',
  },
  {
    icon: <PiMusicNotes />,
    title: 'Tracks processed',
  },
  {
    icon: <BiCoin />,
    title: 'Credits',
  },
  {
    icon: <BiCoinStack />,
    title: 'Additional credits',
  },
]

interface UsageTaskTableProps {
  taskDetailList: Record<string, TaskDetail>
}

/**
 * The table showing the usage data of the selected month, per product.
 */
export const UsageTaskTable = (props: UsageTaskTableProps) => {
  const navigate = useNavigate()

  return (
    <table className="iamp-table usage-table">
      <thead>
        <tr>
          {UsageTaskTableHeaderList.map((header: IampTableColumnHeader) => (
            <IampHeaderIconTitle key={header.title} {...header} />
          ))}
        </tr>
      </thead>

      <tbody>
        {Object.values(props.taskDetailList)
          .sort((a, b) => a.moduleName.localeCompare(b.moduleName))
          .map((detail, index) => (
            <tr key={index}>
              <td>{detail.moduleName}</td>
              <td>{detail.trackProcessedCount}</td>
              <td>{Util.absRound(detail.consumedCreditCount)}</td>
              <td className="additional-credit-column">
                <div>
                  <div className="additional-credit">
                    {Util.absRound(detail.consumedOffPackageCreditCount)}
                  </div>
                  {detail.consumedOffPackageCreditCount > 0 && (
                    <button
                      type="button"
                      className="additional-credit-button"
                      onClick={() => navigate('/tierselection')}
                    >
                      Upgrade
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  )
}
